import ChoiceField from 'admin-config/lib/Field/ChoiceField';
import countries from 'countries-3166';

class CountriesField extends ChoiceField {
    constructor(name) {
        super(name).choices(countries.alpha2().sortByName().toArray().map((el) => {
            return {value: `${el.code}`, label: el.name }
        }));
        this._type = "choices";
    }
}
module.exports = CountriesField;


// WEBPACK FOOTER //
// ./client/app/fields/countries.js